import { render, staticRenderFns } from "./event2.vue?vue&type=template&id=95b0196e"
import script from "./event2.vue?vue&type=script&lang=js"
export * from "./event2.vue?vue&type=script&lang=js"
import style0 from "./event2.vue?vue&type=style&index=0&id=95b0196e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports